import { toast } from "react-toastify";
import {
  addBillInvioceFailure,
  addBillInvoiceStart,
  addBillInvoiceSuccess,
  addNoteFailure,
  addNoteStart,
  addNoteSuccess,
  deleteBillInvoicepFailure,
  deleteBillInvoiceStart,
  deleteBillInvoiceSuccess,
  editBillInvoiceFailure,
  editBillInvoiceStart,
  editBillInvoiceSuccess,
  fetchBillInviocePDFStart,
  fetchBillInvioceStart,
  fetchBillInvoiceFailure,
  fetchBillInvoicePDFFailure,
  fetchBillInvoicePDFSuccess,
  fetchBillInvoiceSuccess,
  fetchTripsSuccess,
  getBillByIdFailure,
  getBillByIdStart,
  getBillByIdSuccess,
} from "./reducer";
import {
  addBillInvioceService,
  deleteBillInvoiceService,
  editBillInvoiceService,
  editNoteService,
  getBillIdService,
  getBillInvioicePDFService,
  getBillInvioiceService,
} from "../../Services/BillInvoiceGSTService";

//thunk for fetch the category list
export const fetchBillInvoiceList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchBillInvioceStart());
      const response = await getBillInvioiceService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchBillInvoiceSuccess({
            billInvoices: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchBillInvoiceSuccess({
            billInvoices: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchBillInvoiceFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchBillInvoiceFailure(error));
    }
  };

//thunk for the addig the category

export const addBillInvioce = (requestParam) => async (dispatch) => {
  try {
    dispatch(addBillInvoiceStart());

    const response = await addBillInvioceService(requestParam);

    if (response) {
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = response?.headers["filename"];
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      toast.success(response.message);
      dispatch(addBillInvoiceSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addBillInvioceFailure("Failed to book trip"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addBillInvioceFailure(error));
  }
};

// // //this is the thunk for delete the category
export const deleteBillInvoice = (invoiceId) => async (dispatch) => {
  try {
    dispatch(deleteBillInvoiceStart());

    const response = await deleteBillInvoiceService(invoiceId);
    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteBillInvoiceSuccess(invoiceId));
    } else {
      toast.error("Failed to delete Booked Trip");
      dispatch(deleteBillInvoicepFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteBillInvoicepFailure(error));
  }
};

// // //this tunk for the edit meal category
export const editBillInvoice = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(editBillInvoiceStart());

    const response = await editBillInvoiceService(id, requestParam);

    if (response) {
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = response?.headers["filename"];
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url);

      toast.success(response.message);
      dispatch(editBillInvoiceSuccess(response));
    } else {
      dispatch(editBillInvoiceFailure("Failed to update Booked Trip"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editBillInvoiceFailure(error));
  }
};

//this thunk is for the get by id
export const fetchBillById = (id) => async (dispatch) => {
  try {
    dispatch(getBillByIdStart());
    const response = await getBillIdService(id);
    if (response?.data) {
      dispatch(getBillByIdSuccess(response.data));
    } else {
      dispatch(getBillByIdFailure("No category found"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(getBillByIdFailure(error));
  }
};

// export const fetchBillInvoicePDFList = (id) => async (dispatch) => {
//   try {
//     const response = await getBillInvioicePDFService(id);

//   } catch (error) {
//     dispatch(fetchBillInvoicePDFFailure(error));
//   }
// };

export const fetchBillInvoicePDFList = (id) => async (dispatch) => {
  try {
    const response = await getBillInvioicePDFService(id);

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = response?.headers["filename"];
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    // const pdfBlob = new Blob([response.data], { type: "application/pdf" });

    // const fileURL = window.URL.createObjectURL(pdfBlob);

    // const link = document.createElement("a");
    // link.href = fileURL;
    // link.download = `BillInvoice_${id}.pdf`;
    // link.click();

    // window.URL.revokeObjectURL(fileURL);

    dispatch(fetchBillInvoicePDFSuccess());
  } catch (error) {
    dispatch(fetchBillInvoicePDFFailure(error));
  }
};

export const updateNote = (id, requestParam) => async (dispatch) => {
  try {
    dispatch(addNoteStart());
    const response = await editNoteService(id, requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addNoteSuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addNoteFailure("Failed to add Note"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addNoteFailure(error));
  }
};
